module.exports = __webpack_public_path__ + "static/media/son-quote.66cdb0c9.mp3";